import { AlertOctagon, AlertTriangle } from 'lucide-react';

import { Badge } from '@/ui/primitives/badge';
import { type DocumentoResumo } from '@fiscoai/contracts';

import { STATUS_CLASSIFICACAO } from './rotulos';

const plural = (n: number, palavra: string) => `${String(n)} ${palavra}${n === 1 ? '' : 's'}`;

/** Andamento da classificação + o que as conferências acusaram (só ícones com contagem). */
export function IndicadorFiscal({ doc }: { doc: DocumentoResumo }) {
  const status = STATUS_CLASSIFICACAO[doc.statusClassificacao];
  return (
    <span className="inline-flex items-center gap-1.5">
      {doc.statusClassificacao !== 'NAO_SE_APLICA' && (
        <Badge tom={status.tom}>{status.rotulo}</Badge>
      )}
      {doc.conferenciasComErro > 0 && (
        <span
          className="inline-flex items-center gap-0.5 text-xs text-perigo tabular"
          aria-label={`${plural(doc.conferenciasComErro, 'erro')} nas conferências`}
        >
          <AlertOctagon className="size-3.5" aria-hidden />
          {doc.conferenciasComErro}
        </span>
      )}
      {doc.conferenciasComAlerta > 0 && (
        <span
          className="inline-flex items-center gap-0.5 text-xs text-alerta tabular"
          aria-label={`${plural(doc.conferenciasComAlerta, 'alerta')} nas conferências`}
        >
          <AlertTriangle className="size-3.5" aria-hidden />
          {doc.conferenciasComAlerta}
        </span>
      )}
    </span>
  );
}
